<template>
  <div>
    <b-button
      v-if="state === 'empty'"
      v-on="{ click: onClick('wip') }"
      :loading="loading"
    >
      Edit
    </b-button>
    <b-button
      v-else-if="state === 'wip'"
      v-on="{ click: onClick('finished') }"
      type="is-success"
      :loading="loading"
    >
      Finish
    </b-button>
    <b-button
      v-else
      v-on="{ click: onClick('wip') }"
      type="is-warning"
      :loading="loading"
    >
      Re-Edit
    </b-button>
  </div>
</template>

<script>
import { computed, ref } from "@vue/composition-api";
import { SnackbarProgrammatic as Snackbar } from "buefy";
import annotations from "@/store/modules/annotations";
import ui from "@/store/modules/ui";

export default {
  setup() {
    const loading = ref(false);
    const annotationState = computed(() => annotations.getState);

    const onClick = newState => async () => {
      // start loading
      loading.value = true;
      const oldState = annotations.getState;
      const oldEditStartedAt = annotations.getEditStartedAt;
      const oldFinishedAt = annotations.getFinishedAt;

      try {
        annotations.setState(newState);
        if (newState === "wip") {
          annotations.setEditStartedAt(Date.now());
        } else if (newState === "finished") {
          annotations.setFinishedAt(Date.now());
        }

        await annotations.postAnnotations(annotations);
        ui.setHasUnsavedChange(false);
      } catch (error) {
        // undo setState
        annotations.setState(oldState);
        annotations.setEditStartedAt(oldEditStartedAt);
        annotations.setFinishedAt(oldFinishedAt);
        // save failed
        console.error(
          "onClick in AnnotationsStateButton failed at postAnnotations: " +
            error
        );
        // warn user of unsaved change
        Snackbar.open({
          message: error.message,
          actionText: "Close",
          type: "is-warning",
          indefinite: true,
          position: "is-top"
        });
      } finally {
        // end loading
        loading.value = false;
      }
    };

    return {
      state: annotationState,
      loading,
      onClick
    };
  }
};
</script>
